module.exports = __webpack_public_path__ + "static/img/2024.a4b02b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2024.png
// module id = CtCy
// module chunks = 1